"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CardBase = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Styling = require("@fluentui/react/lib/Styling");

var React = _interopRequireWildcard(require("react"));

var getClassNames = (0, _react.classNamesFunction)();

var CardBase = function CardBase(props) {
  var styles = props.styles,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? (0, _Styling.getTheme)() : _props$theme,
      children = props.children,
      className = props.className;
  var classNames = getClassNames(styles, {
    theme: theme
  });
  var divProps = (0, _react.getNativeProps)(props, _react.divProperties);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, divProps), {}, {
    className: (0, _react.css)(classNames.root, className),
    children: children
  }));
};

exports.CardBase = CardBase;